import React from "react";

export default function TextField({
  label,
  type = "text",
  id,
  value,
  onChange,
  placeholder,
  required = false,
  rows,
  multiline = false, // if true -> textarea
}) {
  return (
    <div>
      {label && (
        <label
          htmlFor={id}
          className="block mb-2 text-sm font-medium text-gray-900"
        >
          {label}
        </label>
      )}

      {multiline ? (
        <textarea
          id={id}
          rows={rows || 3}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          required={required}
          className="bg-gray-50 border border-gray-300 text-gray-900 rounded-lg
                     focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
        />
      ) : (
        <input
          type={type}
          id={id}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          required={required}
          className="bg-gray-50 border border-gray-300 text-gray-900 rounded-lg
                     focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
        />
      )}
    </div>
  );
}
